import { useState } from "react";
import { siteInfo } from "@/mocks/home";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      setSubmitted(true);
      setEmail("");
    }
  };

  return (
    <footer id="contato" className="relative w-full overflow-hidden">
      <div className="mx-4 md:mx-6 mb-4 md:mb-6 rounded-3xl bg-stone-950 border border-stone-900">
        <div className="relative px-8 md:px-16 py-16 md:py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8 relative z-10">
            <div>
              <h4 className="text-2xl md:text-3xl font-bold text-white mb-6">
                Entre no Ritmo
              </h4>
              <p className="text-stone-500 text-sm leading-relaxed">
                O melhor da noite rock'n'roll te espera. Whiskey e boa música.
              </p>
            </div>

            <div>
              <h5 className="text-sm font-semibold text-white uppercase tracking-wider mb-6">
                Links
              </h5>
              <ul className="space-y-3">
                {[
                  { label: "Home", href: "/" },
                  { label: "Vídeo", href: "#video" },
                  { label: "Inauguração", href: "#inauguracao" },
                  { label: "Contato", href: "#contato" },
                ].map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-stone-400 hover:text-amber-500 text-sm transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h5 className="text-sm font-semibold text-white uppercase tracking-wider mb-6">
                Redes Sociais
              </h5>
              <ul className="space-y-3">
                <li>
                  <a
                    href={siteInfo.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 text-stone-400 hover:text-amber-500 text-sm transition-colors"
                  >
                    <i className="ri-instagram-line text-lg" />
                    Instagram
                  </a>
                </li>
                <li>
                  <a
                    href="https://youtube.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 text-stone-400 hover:text-amber-500 text-sm transition-colors"
                  >
                    <i className="ri-youtube-line text-lg" />
                    YouTube
                  </a>
                </li>
                <li>
                  <a
                    href="https://facebook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 text-stone-400 hover:text-amber-500 text-sm transition-colors"
                  >
                    <i className="ri-facebook-circle-line text-lg" />
                    Facebook
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h5 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
                Newsletter
              </h5>
              <p className="text-stone-500 text-xs mb-4">
                Receba novidades sobre a inauguração e eventos exclusivos.
              </p>
              {submitted ? (
                <div className="flex items-center gap-2 text-amber-500 text-sm">
                  <i className="ri-check-line" />
                  Inscrição realizada!
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="flex items-center gap-0">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Seu e-mail"
                    required
                    className="flex-1 bg-stone-900 border border-stone-800 text-stone-200 text-sm px-4 py-3 rounded-l-xl focus:outline-none focus:border-amber-700 placeholder:text-stone-600"
                  />
                  <button
                    type="submit"
                    className="bg-white text-stone-950 w-11 h-11 flex items-center justify-center rounded-r-xl hover:bg-stone-200 transition-colors"
                  >
                    <i className="ri-arrow-right-line text-lg" />
                  </button>
                </form>
              )}
            </div>
          </div>

          <div className="mt-16 pt-8 border-t border-stone-900 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-stone-600 text-xs">
              {siteInfo.name} — {new Date().getFullYear()}. Todos os direitos reservados.
            </p>
            <p className="text-stone-600 text-xs">
              {siteInfo.address} |{
                " "
              }
              <a
                href={`https://wa.me/${siteInfo.phone.replace(/[^0-9]/g, "")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-stone-400 hover:text-amber-500"
              >
                {siteInfo.phone}
              </a>
            </p>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 overflow-hidden pointer-events-none select-none">
          <span className="block text-[80px] md:text-[120px] lg:text-[160px] font-black text-stone-900/40 leading-none tracking-tighter text-center whitespace-nowrap">
            JACK'S HOUSE
          </span>
        </div>
      </div>
    </footer>
  );
}